import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// ====================================================================
// ziven-custom-tags — forum entry
// ====================================================================
//
// v0.1.0 范围 (Trello #397 任务 C, 辉哥 2026-07-31 拍板):
//   - TagsPage tagTileView extend: 把 tag.attribute('bgImageUrl') 注入
//     li style 的 --tag-bg-image CSS 变量, 让 forum.less 背景图样式生效
//   - fallback: 没 bgImageUrl 的 tag 走 vendor 默认 (背景色 var(--tag-bg))
//
// v0.1.0l 范围 (辉哥 2026-08-01 00:40 反馈):
//   - 帖子列表页 TagHero header 也要支持背景图
//   - TagHero.prototype.style override: 注入 --hero-bg-image CSS 变量
//   - TagHero.prototype.className override: 注入 ziven-custom-tags-header-has-bg-image className
//     (forum.less 用这个 className 触发 60% 黑遮罩)
//
// 跟 ziven-dress-up forum 同款 2.0 pattern (辉哥 2026-07-20 21:38 拍板砍 1.8 兼容).
//
// 技术细节 (重要):
//   - Flarum 2.0 extend() wrap 是先调 original, 再调 callback, 然后返回 original.
//     所以 callback 拿到的 vnode 是 original 创建的, 可直接 mutate vnode.attrs.style
//     加 --tag-bg-image 字段. mithril 渲染时会看到新 style.
//   - extend() callback 不能改返回值, 只能 mutate (所以走 mutating 时用 extend).
//   - override() 是 replacement function, 接管原 method. 适合需要改 return 的场景
//     (如 TagHero.style() 返回 object, override 改 object 加新字段).
//   - Tag model attribute: 走 `this.tag.attribute('bgImageUrl')` 直接读 (Flarum 2.0
//     Model 通用 accessor, 不需要 extend Tag.prototype, 因为 extend() wrap 返回
//     original 值, callback return 会被丢弃).
// ====================================================================

import { extend, override } from 'flarum/common/extend';
import app from 'flarum/common/app';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
import TagHero from 'ext:flarum/tags/forum/components/TagHero';
app.initializers.add('ziven-custom-tags', () => {
  // TagsPage.tagTileView: 在 li 的 style 上加 --tag-bg-image CSS 变量
  // forum.less 用这个变量渲染背景图 + 60% 黑遮罩
  // 没 bgImageUrl 的 tag 走 vendor 默认 (背景色 var(--tag-bg), 不显示遮罩)
  extend(TagsPage.prototype, 'tagTileView', function (vnode, tag) {
    if (!vnode || !vnode.attrs || !tag) return;
    const bgImageUrl = tag.attribute('bgImageUrl');

    // 合并新 style (保留 vendor 原有的 --tag-bg)
    const existingStyle = vnode.attrs.style || {};
    const newStyle = _objectSpread({}, existingStyle);
    if (bgImageUrl) {
      // 有背景图: 加 CSS 变量 + 加 className 让 .forum.less 60% 黑遮罩显示
      newStyle['--tag-bg-image'] = "url(".concat(bgImageUrl, ")");
      vnode.attrs.className = (vnode.attrs.className || '') + ' ziven-custom-tags-has-bg-image';
    } else {
      // 没背景图: 走 vendor 默认背景色 var(--tag-bg), 不显示 zct 遮罩
      // (不要 set --tag-bg-image, 让 .TagTile 的 background-image: var(--tag-bg-image) 解析为空)
      delete newStyle['--tag-bg-image'];
    }
    vnode.attrs.style = newStyle;
  });

  // v0.1.0l: TagHero.className override — 注入 ziven-custom-tags-header-has-bg-image className
  // forum.less 用这个 className 触发 TagHero 60% 黑遮罩
  // 没 headerBgImageUrl 的 tag 走 vendor 默认 (背景色 var(--hero-bg) = tag color)
  override(TagHero.prototype, 'className', function (original) {
    let className = original() || '';
    if (!this.attrs || !this.attrs.model) return className;
    const headerBgImageUrl = this.attrs.model.attribute('headerBgImageUrl');
    if (headerBgImageUrl) {
      className = (className + ' ziven-custom-tags-header-has-bg-image').trim();
    }
    return className;
  });

  // v0.1.0l: TagHero.style override — 注入 --hero-bg-image CSS 变量
  // vendor Hero less: background: var(--hero-bg), 走 zct background-image: var(--hero-bg-image) 覆盖
  override(TagHero.prototype, 'style', function (original) {
    const style = original() || {};
    if (!this.attrs || !this.attrs.model) return style;
    const headerBgImageUrl = this.attrs.model.attribute('headerBgImageUrl');
    if (headerBgImageUrl) {
      style['--hero-bg-image'] = "url(".concat(headerBgImageUrl, ")");
    }
    return style;
  });
});